import 'regenerator-runtime/runtime';
import PixelConfigurationHttpClient from '../clients/pixelConfigurationHttpClient';
import PixelConfigurationURLClient from '../clients/pixelConfigurationURLClient';
import logger from '../common/logger';
import EncryptionService from '../services/encryptionService';
import TrackingManager from '../guCommonTracking';
import {getAltDomain} from '../utils/urls'


const ENABLE_GU_PIX = false;

const getBrandName = (domain) => {
  try {
    let brandName = null;
    const domainParts = domain.split('.');
    const nakedDomain = domainParts[domainParts.length - 2];

    // Check if the domain has a hyphen in the second-to-last part (e.g., brandname-faketest.com)
    if (nakedDomain.indexOf('-') > -1 && (domainParts.length === 2 ||
      domainParts[0] === 'funnel' || domainParts[0] === 'v3staging')) {
      // Handle case for hyphenated brand names (e.g., offer-brandname.com)
      brandName = nakedDomain.split('-')?.[1] || null;
    }
    // Handle case where brand name is a subdomain (e.g., offer.brandname.com)
    else if (domainParts.length >= 3) {
      brandName = domainParts[1];
    }

    return brandName;
  } catch (e) {
    return null;
  }
}
// getBrandName('foo.bar.com') =>'bar'
// getBrandName('brand-faketest.com') => 'faketest'
// getBrandName('funnel.brand.com') => 'brand'
// getBrandName('v3staging.brand.com') => 'brand'
// getBrandName('brand.com') => null

const validateGetPixelConfigFromBrandNameAndAffIdAndOIdParams = (brandName, affiliateId, offerId) => {
  const validationResult = [true, []]
  const pushFieldFailed = (argName, message) => {
    validationResult[0] = false;
    validationResult[1].push({ args: `${argName}`, message })
  }

  if (!brandName) pushFieldFailed('brandName', 'Brand name is required')
  if (!affiliateId) pushFieldFailed('affiliateId', 'Affiliate Id is required')
  if (!offerId) pushFieldFailed('offerId', 'Offer Id is required')

  return validationResult
}

const PixelConfigurationService = {
  getPixelConfigurationForCurrentPageAsync: async () => {
    try {
      let pixelConfig = null;
      if(ENABLE_GU_PIX){
        pixelConfig = PixelConfigurationURLClient.getPixelConfigFromUrl();
      }
      if (!pixelConfig) {
        const oid = window?.gu_qs?.oid && window?.gu_qs?.oid != '' ? window?.gu_qs?.oid : TrackingManager.config?.offer_id ?? null;
        const affId = window?.gu_qs?.aff_id;
        if (!oid || !affId) {
          logger.info('No affid or oid');
          return null;
        }
        else {
          let fromReferrer = false;
          let domain = getAltDomain() || TrackingManager.config?.domain || window.location.host;
          console.log(`Using domain ${domain} for pixel config, TrackingManager.config.domain = ${TrackingManager.config?.domain}`)
          let brandName = getBrandName(domain);

          if(!brandName && window.gu_qs?.gu_brand){
            brandName = window.gu_qs['gu_brand'];
            fromReferrer = true;
          }

          const requestPayload = {
            offerId: oid,
            affiliateId: affId,
            domain: domain,
            pageUrl: window.location.toString()
          };

          if (brandName) {
            requestPayload.brandName = brandName;
          }

          const encryptedPayload = EncryptionService.encrypt(JSON.stringify(requestPayload));
          const response = await PixelConfigurationHttpClient.getPixelConfigurationAsync(encryptedPayload);
          if (response?.data?.result) {
            let decryptedConfig = EncryptionService.decrypt(response.data.result);
            if (decryptedConfig) {
              decryptedConfig = JSON.parse(decryptedConfig);
              pixelConfig = decryptedConfig?.pixelConfigs;
              if(fromReferrer){
                window.gu_qs['gu_brand'] = brandName;
                window.sessionStorage.setItem('gu_brand', brandName);
              }
            }
          } else if(fromReferrer) {
            requestPayload.brandName = undefined;
            const encryptedPayload = EncryptionService.encrypt(JSON.stringify(requestPayload));
            const response = await PixelConfigurationHttpClient.getPixelConfigurationAsync(encryptedPayload);
            if (response?.data?.result) {
              let decryptedConfig = EncryptionService.decrypt(response.data.result);
              if (decryptedConfig) {
                decryptedConfig = JSON.parse(decryptedConfig);
                pixelConfig = decryptedConfig?.pixelConfigs;
              }
            }
          }
        }
      }
      return pixelConfig;

    } catch (e) {
      return null;
    }
  },
  async getPixelConfigFromBrandNameAndAffIdAndOId(brandName, affiliateId, offerId) {
    try {
      const [isValid, validationErrors] = validateGetPixelConfigFromBrandNameAndAffIdAndOIdParams(brandName, affiliateId, offerId)
      if (!isValid) {
        logger.warn('Cannot get Pixel configs', { validationErrors, args: { brandName, affiliateId, offerId } });
        return null;
      }

      const requestPayload = {
        brandName,
        offerId,
        affiliateId
      }

      const encryptedPayload = EncryptionService.encrypt(JSON.stringify(requestPayload));
      const response = await PixelConfigurationHttpClient.getPixelConfigurationAsync(encryptedPayload);

      if (!response?.data?.result) {
        logger.info('No pixel configs found for ', { brandName, affiliateId, offerId });
        return null;
      }

      let decryptedConfig = EncryptionService.decrypt(response.data.result);

      if (!decryptedConfig) {
        logger.warn('No pixel configs found for ', { brandName, affiliateId, offerId });
        return null;
      }

      decryptedConfig = JSON.parse(decryptedConfig);
      return decryptedConfig?.pixelConfigs;
    } catch (error) {
      console.error('Error occurred in getPixelConfigFromBrandNameAndAffIdAndOId()', error)
      return null;
    }
  },
};

export default PixelConfigurationService;